export interface CampaignRequest {
    nome: string;
    dataInicio: string;
    dataFim: string;
    exclusivo: boolean;
    tipo: string;
    condicoes: Conditions[];
    resultados: Result[];
}

export class CampaignRequestAPI {
    constructor(data?: CampaignRequest) {
        if (data) {
            Object.assign(this, data);
        }
    }

    nome: string;
    dataInicio: string;
    dataFim: string;
    exclusivo: boolean;
    tipo: string;
    condicoes: Conditions[];
    resultados: Result[];
}

export interface Conditions {
    id?: number;
    campanhaId?: number;
    campo: string;
    operador: string;
    numeroItem: string;
    valor: string;
}

export interface Result {
    id?: number;
    campanhaId?: number;
    email: string;
    numeroItem: string;
    qtd: number;
    originalQtd: number;
    desconto: number;
    percentualCota?: number;
    // Fase 2 (DESCONTO_ATINGIR_META): bonificação proporcional (%) e tipo de
    // benefício por item (enum CampanhaResultadoTipoEnum do backend).
    qtdPercentual?: number | null;
    tipo?: string | null;
}

export interface CampaignRequestOrder {
    paymentConditionId: string;
    date?: string;
    clientState?: string;
}
